import React, { useEffect, useState } from "react";
import { api, inr } from "@/lib/api";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, BarChart, Bar } from "recharts";

export default function AdminAnalytics() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/analytics").then((r) => setStats(r.data)); }, []);
  if (!stats) return <div className="text-hyd-text2">Loading...</div>;
  return (
    <div>
      <h1 className="font-display text-3xl font-extrabold">Analytics</h1>
      <p className="text-hyd-text2 text-sm">Sales & product insights</p>

      <div className="mt-5 bg-hyd-panel border border-hyd-border rounded-xl p-4">
        <h3 className="font-display text-lg font-bold mb-3">Daily revenue (last 14 days)</h3>
        {stats.daily.length === 0 ? (
          <div className="text-hyd-text3 text-sm py-10 text-center">No sales data yet.</div>
        ) : (
          <div className="h-64">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={stats.daily}>
                <CartesianGrid strokeDasharray="3 3" stroke="#262626" />
                <XAxis dataKey="date" stroke="#A3A3A3" tick={{ fontSize: 11 }} />
                <YAxis stroke="#A3A3A3" tick={{ fontSize: 11 }} />
                <Tooltip contentStyle={{ background: "#141414", border: "1px solid #262626", borderRadius: 8 }} labelStyle={{ color: "#FFD700" }} />
                <Line type="monotone" dataKey="revenue" stroke="#FFD700" strokeWidth={2} dot={{ fill: "#E53935" }} />
              </LineChart>
            </ResponsiveContainer>
          </div>
        )}
      </div>

      <div className="grid md:grid-cols-2 gap-4 mt-4">
        <div className="bg-hyd-panel border border-hyd-border rounded-xl p-4">
          <h3 className="font-display text-lg font-bold mb-3">Top-selling products</h3>
          {stats.top_products.length === 0 ? (
            <div className="text-hyd-text3 text-sm">No sales yet</div>
          ) : (
            <div className="h-64">
              <ResponsiveContainer width="100%" height="100%">
                <BarChart data={stats.top_products}>
                  <CartesianGrid strokeDasharray="3 3" stroke="#262626" />
                  <XAxis dataKey="name" stroke="#A3A3A3" tick={{ fontSize: 10 }} interval={0} angle={-20} textAnchor="end" height={60} />
                  <YAxis stroke="#A3A3A3" tick={{ fontSize: 11 }} />
                  <Tooltip contentStyle={{ background: "#141414", border: "1px solid #262626", borderRadius: 8 }} />
                  <Bar dataKey="qty" fill="#E53935" radius={[6, 6, 0, 0]} />
                </BarChart>
              </ResponsiveContainer>
            </div>
          )}
        </div>
        <div className="bg-hyd-panel border border-hyd-border rounded-xl p-4">
          <h3 className="font-display text-lg font-bold mb-3">Order pipeline</h3>
          <div className="space-y-2">
            {Object.entries(stats.by_status || {}).map(([s, c]) => (
              <div key={s} className="flex items-center gap-3">
                <span className="text-xs uppercase tracking-widest w-24 text-hyd-text2">{s}</span>
                <div className="flex-1 h-2 bg-hyd-bg rounded-full overflow-hidden">
                  <div className="h-full bg-hyd-gold" style={{ width: `${Math.min(100, (c / Math.max(1, stats.total_orders)) * 100)}%` }} />
                </div>
                <span className="text-hyd-gold font-bold text-sm w-10 text-right">{c}</span>
              </div>
            ))}
            {Object.keys(stats.by_status || {}).length === 0 && <div className="text-hyd-text3 text-sm">No orders</div>}
          </div>
          <div className="mt-4 text-hyd-gold font-display text-2xl">{inr(stats.revenue)}</div>
          <div className="text-xs text-hyd-text2">lifetime revenue</div>
        </div>
      </div>
    </div>
  );
}
